import React from "react";
import "../ConfigurePayout.css";
import { TextField } from "@mui/material";

const BankDetailsComponent = (props) => {
  return (
    <div
      className="form-column"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "20px", // ✅ uniform gap between inputs
      }}
    >
      <TextField
        className="mui-text-field"
        label="Account Name"
        name="accountName"
        value={props.formDataBank?.accountName || ""}
        onChange={props.handleChangeBankDetails}
        fullWidth
      />

      <TextField
        className="mui-text-field"
        label="Account Number"
        name="accountId"
        value={props.formDataBank?.accountId || ""}
        onChange={props.handleChangeBankDetails}
        fullWidth
      />

      <TextField
        className="mui-text-field"
        label="IFSC"
        name="ifsc"
        value={props.formDataBank?.ifsc || ""}
        onChange={props.handleChangeBankDetails}
        fullWidth
      />
    </div>
  );
};

export default BankDetailsComponent;
